import { Injectable } from '@angular/core';

import { ModuleItem } from '@core/config';

import { MwAppModulesApiService } from './app-modules-api.service';

@Injectable()
export class MwAppModulesService {
  constructor(private apiService: MwAppModulesApiService) {}

  navigate(item: ModuleItem): void {
    if (item.autoLogin) {
      this.apiService.getAutoLoginLink(item.url).subscribe((result) => {
        window.open(result.url, '_blank');
      });
    } else {
      window.open(item.url, '_blank');
    }
  }
}
